import { Box, Grid, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useMaterialUIController } from 'context';
import { StandaloneAutoCompleteSelect } from '@components/StandaloneAutoCompleteSelect';
import { getCrmColors } from '@layouts/pages/CRM/kanban-board/crm-theme';

interface Props {
    withLeads: boolean;
    onWithLeads: (value: boolean) => void;
    boards: { id: string; name: string }[];
    boardId: string | null;
    onBoard: (id: string) => void;
    columns: { id: string; name: string }[];
    columnId: string | null;
    onColumn: (id: string) => void;
}

/// Só pessoas, ou pessoas e leads numa coluna do funil.
export const ImportTarget = ({
    withLeads, onWithLeads, boards, boardId, onBoard, columns, columnId, onColumn,
}: Props) => {
    const { t } = useTranslation();
    const [controller] = useMaterialUIController();
    const cc = getCrmColors(controller.darkMode);

    return (
        <Box>
            <Typography sx={{ fontSize: 14, fontWeight: 600, color: cc.textPrimary, mb: 1 }}>
                {t('people.importar.oQueCriar')}
            </Typography>

            <ToggleButtonGroup
                exclusive
                size="small"
                value={withLeads ? 'leads' : 'people'}
                onChange={(_, value) => value && onWithLeads(value === 'leads')}
            >
                <ToggleButton value="people" sx={{ px: 2.5 }}>{t('people.importar.soPessoas')}</ToggleButton>
                <ToggleButton value="leads" sx={{ px: 2.5 }}>{t('people.importar.pessoasELeads')}</ToggleButton>
            </ToggleButtonGroup>

            {withLeads && (
                <Grid container spacing={2} sx={{ mt: 1, maxWidth: 720 }}>
                    {boards.length > 1 && (
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <Typography sx={{ fontSize: 13, color: cc.textSecondary, mb: 0.5 }}>
                                {t('people.importar.quadro')}
                            </Typography>
                            <StandaloneAutoCompleteSelect
                                options={boards.map((board) => ({ value: board.id, label: board.name }))}
                                value={boardId}
                                onChange={(value) => onBoard(value as string)}
                            />
                        </Grid>
                    )}
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Typography sx={{ fontSize: 13, color: cc.textSecondary, mb: 0.5 }}>
                            {t('people.importar.coluna')}
                        </Typography>
                        <StandaloneAutoCompleteSelect
                            options={columns.map((column) => ({ value: column.id, label: column.name }))}
                            value={columnId}
                            onChange={(value) => onColumn(value as string)}
                        />
                    </Grid>
                </Grid>
            )}
        </Box>
    );
};
